import { FC, ReactNode } from "react";

import styled from "@emotion/styled";
import CompletedWeekBadge from "../WeightReadings/CompletedWeekBadge";

/**
 * Shown in place of the protein ring once the daily protein target is met. It
 * reuses the weight-streak reward seal (the slowly-spinning scalloped badge)
 * with the day's protein total at its centre, so the number the ring was
 * showing stays readable after the ring turns into a badge.
 */
const Wrapper = styled.div`
  width: 88px;
  height: 88px;
  flex-shrink: 0;
`;

const ProteinTargetBadge: FC<{ children: ReactNode }> = ({ children }) => (
  <Wrapper>
    <CompletedWeekBadge speed="12800ms">{children}</CompletedWeekBadge>
  </Wrapper>
);

export default ProteinTargetBadge;
